import { DesktopFilterSelectOptionHrefParams } from './DesktopFilterSelectOption.types';
import { QUERY } from '@/constants/common';
import { KeywordsSource } from '@/components/SearchPanel/components/SearchSuggestions.types';

export function getDesktopFilterSelectOptionHref({
  clearUrl,
  value,
  baseSearchParams,
  queryString,
  propertyParam,
  queryParam,
}: DesktopFilterSelectOptionHrefParams) {
  const searchParams = new URLSearchParams(baseSearchParams ?? queryString);
  const key =
    baseSearchParams || propertyParam
      ? `p[${propertyParam}]`
      : `${QUERY.q}[${queryParam}]`;

  searchParams.delete(QUERY.userId);
  searchParams.set(QUERY.keywordsSource, KeywordsSource.Typewritten);

  if (value !== undefined) {
    searchParams.set(key, value);
  } else {
    searchParams.delete(key);
  }

  return searchParams.size
    ? `${clearUrl}?${searchParams.toString()}`
    : clearUrl;
}
